import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';  // eta linea es para tranferir datos y cerrar dialog
import { NgForm } from '@angular/forms';
import { Barcos } from 'src/app/models/barcos';
import { BarcoService } from 'src/app/services/barco.service';
import Swal from 'sweetalert2';
import { DOCUMENT } from '@angular/common';



const info_SCHEMA = {
  "idempresa": "",
  "_id": "",
  "nombrebarco": "",
  "emailbarco": "",


}








@Component({
  selector: 'app-modalbarco',
  templateUrl: './modalbarco.component.html',
  styleUrls: ['./modalbarco.component.css']
})
export class ModalbarcoComponent implements OnInit {

 // @HostListener("focus")
  
  registros: Barcos[];
  nuevoRegistro = false;
  idempresa = "";
  emailempresa = "";
  nombrebarco = "";
  contenidoAcambiado = false;

  infoanterior = '';
  dataSchema = info_SCHEMA;
  emailbarco = "";
  lineaPosicion = ""; //esta es la posickon dle renglon que se esta editando
  lineareal = 0;   //esta es la linea real donde se encuentra le cursor





  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ModalbarcoComponent>,
    private barcoService: BarcoService,
    @Inject(DOCUMENT) document
  ) { }

  ngOnInit() {
    this.idempresa = this.data.idempresa;



    this.listadototal();
  }



  detectalaguncambio(indice: string, valorCampo, nombreCampo: string, posicion: number) {
    // alert (valorCampo);
    // console.log('cambios', indice);
    ///this.claveHospital="";
    //this.nombreHospital="";

    this.lineaPosicion = String(posicion);

    // estos campos son las validacciones que se haran para poder ser guardados
    // if (nombreCampo == "emailbarco") {
    //   this.emailbarco = valorCampo;
    //   // console.log("clave", this.claveHospital)
    // }

    // if (nombreCampo == "nombrebarco") {
    //   this.nombrebarco = valorCampo;
    //   // console.log("clave2", this.nombreHospital)
    // }



    this.contenidoAcambiado = true; // esta indica que la linea o una informacion sobre la linea a cambiado
    this.lineareal = posicion;
    // aqui visualiza el icono de edicion
    //  var valor = document.getElementById('3-1').contains.toString;
    // var valor = this.abc.nativeElement.value
    // if (document.getElementById(indice + "-1").value<>"") {

    // }



    if (this.nuevoRegistro) {
      if (this.nombrebarco != '') {
        this.MuestraIconosOpcioneslistado(indice, 3);
      } else {
        this.MuestraIconosOpcioneslistado(indice, 2)
      }
    } else {
      this.MuestraIconosOpcioneslistado(indice, 4)
    }



  }


  // este procedimeinto habilita de dehabilta los icono de cada renglon, indicando el status del momenot
  MuestraIconosOpcioneslistado(indice: string, opcion: number) {
    // en ocasiones el indice que viene dle parametro viene en el siguiene formato "2-1"
    // lo que se ocupa es detectar ese formato y extraer el primer numero que equivale a la linea
    // y se le asigna a la variable lineaPosicion
    //let lineaPosicion;
    indice = String(indice);


    let posicioncoma = indice.indexOf("-", 0);
    if (posicioncoma != -1) {

      this.lineaPosicion = indice.substring(0, posicioncoma);
    } else {
      this.lineaPosicion = indice;
    }

    //ESta opcion habilita y deshabikita los inconos para representar que esta grabado y estan editando

    switch (opcion) {
      case 3: {
        // los numeros equivaklen las posiciones en la lista  las cuales se desactivan y activan dependiendo
        // a la opcion o la linea en que se enceuntran
        document.getElementById(this.lineaPosicion + "-3").style.display = "inline-block"  /// paloma de aceptado
        document.getElementById(this.lineaPosicion + "-4").style.display = "none"          /// edit
        document.getElementById(this.lineaPosicion + "-5").style.display = "inline-block"            /// aun no se graba
        // ya puede grabarlo
        break;
      }

      case 4: {
        document.getElementById(this.lineaPosicion + "-3").style.display = "none"
        document.getElementById(this.lineaPosicion + "-4").style.display = "inline-block"
        document.getElementById(this.lineaPosicion + "-5").style.display = "inline-block"

        break;
      }





      default: {
        //statements; 
        break;
      }

    }

  }

  camposObligatoriosValidados(renglon: string) {
    //renglon = renglon +1 

    let valor1 = (<HTMLInputElement>document.getElementById(renglon + '-1')).value


    if ((valor1 != '') || (valor1 == null)) {
      return true;
    } else {
      return false;
    }

  }


  async onKeyTab(KeyboardEvent, Listado: Barcos) {
    try {

      let index: string = KeyboardEvent.currentTarget.id;
      var posicioncoma = index.indexOf("-", 0);
      var lineaPosicion = index.substring(0, posicioncoma);


      if (this.contenidoAcambiado == true) { //esto queire decir que algun celda del grid ha cambiado
        this.contenidoAcambiado = false;
        let validado: boolean = this.camposObligatoriosValidados(lineaPosicion);
        if (validado) {

          Listado.nombrebarco = (<HTMLInputElement>document.getElementById(lineaPosicion + '-1')).value;
          Listado.emailbarco = (<HTMLInputElement>document.getElementById(lineaPosicion + '-2')).value;
          Listado.idempresa = this.idempresa;



          this.guardaInfo(Listado, index, "tab");


          //  Listado.idhospital=this.idhospital;
          lineaPosicion = String(Number(lineaPosicion) + 1);
          var nuevoindice = lineaPosicion + "-" + "1"; // incrementa un 1 al indice para pasar a la nueva posicion





          const agregaLinea = new Promise<void>((resolve, reject) => {
            this.addData();

            resolve();
          });

          agregaLinea.then(() => {

            setTimeout(() => {
              // espera 100 milisegundos para posicionar el cursor en el siguienete registro vacio
              (<HTMLInputElement>document.getElementById(lineaPosicion + '-1')).value = "";
              (<HTMLInputElement>document.getElementById(lineaPosicion + '-2')).value = "";
              (<HTMLInputElement>document.getElementById(lineaPosicion + '-3')).value = "";

              document.getElementById(nuevoindice).focus();



            }, 50);
          })


        } else {
          // en el casop de que no hay complido la validacion de campos


        }









      } else if (Listado.nombrebarco != '') {
        let posicioncoma = index.indexOf("-", 0);
        lineaPosicion = index.substring(0, posicioncoma);
        var nuevoindice = (Number(lineaPosicion) + 1) + "-" + "1"; // incrementa un 1 al indice para pasar a la nueva posicion

        document.getElementById(nuevoindice).focus();

      } else {
        var nuevoindice = lineaPosicion + "-" + "1"; // incrementa un 1 al indice para pasar a la nueva posicion

        setTimeout(() => {
          // espera 100 milisegundos para posicionar el cursor en el siguienete registro vacio
          // this.addData();
          document.getElementById(nuevoindice).focus();

        }, 100);

      }






    } catch (error) {

      //  nuevoindice = (lineaPosicion) 1 1) + "-" + "1";

      setTimeout(() => {
        //     // espera 100 milisegundos para posicionar el cursor en el siguienete registro vacio
        document.getElementById(lineaPosicion + "1").focus();
        this.MuestraIconosOpcioneslistado(nuevoindice, 8);  // pinta los iconos
      }, 100);

      // cuando marcr un error es que no enceuntra la sigueinte linea y en ese momenot 
      // se crea el nuevo renglon



      // const agregaLinea = new Promise<void>((resolve, reject) => {
      //   this.addData();
      //   resolve();
      // });

      // agregaLinea.then(() => {
      //   this.nuevoRegistro = true;  // esto indica q se creo un nuevo renglon
      //   setTimeout(() => {
      //     // espera 100 milisegundos para posicionar el cursor en el siguienete registro vacio
      //     document.getElementById(nuevoindice).focus();
      //     this.MuestraIconosOpcioneslistado(nuevoindice, 8);  // pinta los iconos
      //   }, 100);
      // })













    }

  }


  addData() {

    //agrega un renglon vacio
    // this.paginator._changePageSize(this.paginator.pageSize);
    //this.dataSource.data = [...this.dataSource.data, this.dataSchema];
    this.dataSchema = info_SCHEMA;

    // this.registros=[];

    this.registros.push(this.dataSchema)


  }




  guardarDatos(listado: Barcos, indice) {

    let idUnicoRenglon = "";
    let posicioncoma = indice.indexOf("-", 0);
    let lineaPosicion = indice.substring(0, posicioncoma);
    if (lineaPosicion == '') {
      lineaPosicion = indice;
    }

    // aqui asignar le valor unico del renglon creado o modificado
    idUnicoRenglon = (<HTMLInputElement>document.getElementById(lineaPosicion + '-0')).value;

    // si el valor unico dle renglon esta sin valor entonces quiere decir que es nuevo le registro
    if ((idUnicoRenglon == null) || (idUnicoRenglon == '')) {


      this.barcoService.agregar(listado)
        .subscribe(resp => {
          if (resp['ok'] == true) {

            (<HTMLInputElement>document.getElementById(lineaPosicion + '-0')).value = resp['nuevainfo']._id;
            //   this.avanzarindex(indice, "tabs");



            return true;



          }


        });



    } else {
      this.barcoService.actualizar(listado)
        .subscribe(resp => {
          if (resp['ok'] == true) {


          }


        });
    }

  }









  showConfirm(idregistro: string, indiceborrar: number) {

    Swal.fire({
      title: 'Are you sure?',
      text: "DELETE RECORD!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {

        this.borrarRegistro(idregistro, indiceborrar)


      }
    })




  }


  cancelarventana() {
    this.dialogRef.close({ aceptado: 'true' });
  }

  muestraaviso() {
    // esta opcion se mostrara cada vez que se graba un nuevo registro o se modifica
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: 'Your work has been saved',
      showConfirmButton: false,
      timer: 1000
    })
  }


  onKeyup(KeyboardEvent, listado: Barcos): void {
    let index = KeyboardEvent.currentTarget.id;

    //console.log("contenido a cambiado", this.contenidoAcambiado);
    // if (this.contenidoAcambiado == true) {
    // si contenido cambio (esto viene del evento change)
    // this.contenidoAcambiado = false;  // se convierte a false para que ya no entre

    //********************aqui se desglosa e index para cerrar la edicio

    // this.guardaInfo(listado, index, "up");



    // } else {
    this.avanzarindex(index, "up");  //auqnye no haya cambiado algun contenido se ejecuta la opcion para bajar el cursr a la sigueinte poscion
    // }
  }


  onKeyRight(KeyboardEvent, listado: Barcos): void {
    let index = KeyboardEvent.currentTarget.id;

    this.avanzarindex(index, "right");  //se llama al procedimeinto, el index es la posicin actual dle cuersor y up es un variable que identifica que accion se tomo

  }

  onKeyLeft(KeyboardEvent, listado: Barcos): void {
    let index = KeyboardEvent.currentTarget.id;

    this.avanzarindex(index, "left");  //se llama al procedimeinto, el index es la posicin actual dle cuersor y up es un variable que identifica que accion se tomo

  }

  addRegistro(forma: NgForm) {
    // this.HospitalService.agregar(this.registros)

    if (forma.invalid) {
      Object.values(forma.controls).forEach(control => {
        control.markAsTouched();
      });
      //  return;
    } else {


      this.barcoService.agregar(forma.value)
        .subscribe(resp => {
          // alert ( resp.clavehospital);

          this.registros.push({

            _id: resp['barcosGuardado']._id,
            idempresa: resp['barcosGuardado'].idempresa,
            nombrebarco: resp['barcosGuardado'].nombrebarco,
            emailbarco: resp['barcosGuardado'].emailbarco,

          });

          forma.resetForm();

        })


    }
  }

  onfocuselect2() {
    console.log("---------2")

  }





  onBlurMethod(event,
    registro): void {
    if (this.lineaPosicion == '') { }

    let index = this.lineaPosicion;

    if (this.contenidoAcambiado == true) { //esto queire decir que algun celda del grid ha cambiado
      
        this.contenidoAcambiado = false;  //ahora lo pondre a false
        console.log("niuevos datos", registro);
        this.guardaInformacion(registro, index);
      




    }



    // console.log ("----renglon",this.lineaPosicion);
    // console.log('Focus Is Lost for this Element', registro);
  }


  onBlurMethod2(event,
    registro): void {




    console.log("----focus", this.lineaPosicion);

  }



  guardaInfo(Listado: Barcos, index, direccion: string) {



    const informacionguardada = new Promise((resolve, reject) => {
      let valorRetornado = this.guardarDatos(Listado, index); //una vez que se deetctan cambios se procede a gusrdarlos
      resolve(valorRetornado);
    });



    informacionguardada.then(() => {



      this.MuestraIconosOpcioneslistado(index, 6);
      // this.listadototal();



      this.muestraaviso();
      //  this.avanzarindex(index, direccion);




    })




  }




  guardaInformacion(Listado: Barcos, index) {



    const informacionguardada = new Promise((resolve, reject) => {
      let valorRetornado = this.guardarDatos(Listado, index); //una vez que se deetctan cambios se procede a gusrdarlos
      resolve(valorRetornado);
    });



    informacionguardada.then(() => {



      this.MuestraIconosOpcioneslistado(index, 6);
      // this.listadototal();



    })




  }








  onkeyDown(KeyboardEvent, Listado: Barcos): void {
    let index = KeyboardEvent.currentTarget.id;
    // if (this.contenidoAcambiado == true) { //esto queire decir que algun celda del grid ha cambiado
    //  this.contenidoAcambiado = false;  //ahora lo pondre a false



    // this.guardaInfo(Listado, index, "down");
    //this.avanzarindex(index, "down");


    // } else {  //si no ha cambiado simplemente avanza
    this.avanzarindex(index, "down");
    // }



  }


  avanzarindex(indice: string, opcion: string) {  //es la poscion del cursor y opcion es la accion que identifica la flecha
    let posicionCaracter = 0;
    let numcolumna = 0;
    let nuevaposicionRenglon = 0;
    let renglon = "";
    let siguienteinmediatoRenglon = "";
    let nuevanumcolumna = 0;

    let posicion = indice.indexOf("-");// busca dentro del indice la posicion (-)
    if (opcion == "down") {  //si se presiono el boton abajo
      posicionCaracter = indice.indexOf("-")
      numcolumna = +indice.substr(posicionCaracter + 1, 10);
      renglon = indice.substring(0, posicionCaracter);


      nuevaposicionRenglon = Number(renglon) + 1;
      siguienteinmediatoRenglon = (nuevaposicionRenglon + "-" + numcolumna);

    } else if (opcion == "up") {
      posicionCaracter = indice.indexOf("-")

      numcolumna = +indice.substr(posicionCaracter + 1, 10);
      renglon = indice.substring(0, posicionCaracter);
      nuevaposicionRenglon = Number(renglon) - 1;
      siguienteinmediatoRenglon = (nuevaposicionRenglon + "-" + numcolumna)

      // let cadenasobrante=indice.substring(0,posicion);
      // var siguienterenglonString = numcolumna.toString().concat(cadenasobrante);
    } else if (opcion == "left") {
      posicionCaracter = indice.indexOf("-");
      numcolumna = +indice.substr(posicionCaracter + 1, 10);
      renglon = indice.substring(0, posicionCaracter);
      nuevanumcolumna = Number(numcolumna) - 1;
      if (nuevanumcolumna != 0) {
        siguienteinmediatoRenglon = (renglon + "-" + nuevanumcolumna)
      } else {
        siguienteinmediatoRenglon = (renglon + "-1");
      }



    } else if (opcion == "right") {
      posicionCaracter = indice.indexOf("-");
      numcolumna = +indice.substr(posicionCaracter + 1, 10);
      renglon = indice.substring(0, posicionCaracter);
      nuevanumcolumna = Number(numcolumna) + 1;
      siguienteinmediatoRenglon = (renglon + "-" + nuevanumcolumna)

    }




    //aqui asigne la posicon gurdada para qu brincara al siguiente input
    let element = document.getElementById(siguienteinmediatoRenglon);
    element.focus();





  }


  listadototal() {

    this.barcoService.listado(this.idempresa).
      subscribe(resp => {
        this.registros = resp;
        console.log(this.registros);
      })




  }

  borraRegistro(idregistro: string, indice: number) {
    this.showConfirm(idregistro, indice);
    // this.borrarRegistro(idregistro,indice)
  }


  borrarRegistro(idborrar: string, indiceborrar: number) {
    this.barcoService.borrar(idborrar)
      .subscribe(resp => {
        console.log(resp);
        this.registros.splice(indiceborrar, 1);
      })
  }


  focusFunction() {
    alert("hola");
  }

}


